import { getBillingApiOrigin } from './billing-http';

export type SelfServeRegisterBody = {
  email: string;
  name: string;
  password: string;
  password_confirmation: string;
};

export type SelfServeRegisterResponse = {
  message?: string;
  user_id?: string | number;
  email?: string;
};

export async function postSelfServeRegister(
  body: SelfServeRegisterBody
): Promise<SelfServeRegisterResponse> {
  const apiOrigin = getBillingApiOrigin();
  const response = await fetch(`${apiOrigin}/api/v1/self-serve/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const resBody = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMessage = resBody?.message || resBody?.error || '';
    const fallback =
      response.status === 409
        ? 'This email is already registered.'
        : response.status === 503
          ? 'Self-serve signup is temporarily unavailable. Please try again later.'
          : response.status === 422
            ? 'Please check the form and try again.'
            : `Registration failed (${response.status})`;
    const error = new Error(errorMessage || fallback);
    (error as Error & { status?: number }).status = response.status;
    throw error;
  }

  return (resBody ?? {}) as SelfServeRegisterResponse;
}
